import { styled } from 'theme'
import { Box, Flex } from 'components/elements'
import { ShimmerCss, ToggleCss, TitleCss, DescriptionCss, Tags2Css } from '.'

export type AvatarStyle = 'rounded' | 'square'
export type AvatarSize = 'sm' | 'md' | 'lg'

export const ShimmerIcon = styled(Box, {
  variants: {
    variant: {
      rounded: { borderRadius: '$radii$rounded' },
      square: { borderRadius: '$radii$sm' },
    },
    size: {
      sm: { width: 20, height: 20 },
      md: { width: 32, height: 32 },
      lg: { width: 48, height: 48 },
    },
  },
  defaultVariants: {
    variant: 'rounded',
    size: 'md',
  },
})

export interface AvatarShimmerProps {
  showToggle?: boolean
  showIcon?: boolean
  showStatus?: boolean
  iconStyle?: AvatarStyle
  iconSize?: AvatarSize
}

export const AvatarShimmer = ({
  showToggle,
  showIcon,
  showStatus,
  iconStyle,
  iconSize,
}: AvatarShimmerProps) => (
  <Flex align="center">
    {showToggle && <Box css={{ ...ShimmerCss, ...ToggleCss }}></Box>}
    <Flex align="center" css={{ ml: showToggle ? '$space$4' : 0 }}>
      {showIcon && (
        <ShimmerIcon
          variant={iconStyle}
          size={iconSize}
          css={{ ...ShimmerCss }}
        />
      )}
      {showStatus ? (
        <Box css={{ ...ShimmerCss, ...Tags2Css, mr: '$space$5' }}></Box>
      ) : (
        <Flex
          direction="column"
          css={{ ml: showIcon ? '$space$8' : 0, flex: 1 }}
        >
          <Box css={{ ...ShimmerCss, ...TitleCss, mb: '$space$2' }} />
          <Box css={{ ...ShimmerCss, ...DescriptionCss }} />
        </Flex>
      )}
    </Flex>
  </Flex>
)
